import React from 'react';
import { ProgressBar } from 'baseui/progress-bar';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { overrides, ...rest } = props;
	const HTMLAttrs = getHTMLAttributes(props);
	const showLabel = props.showLabel && props.size !== 'large';
	return (
		<ProgressBar
			ref={ref}
			{...rest}
			showLabel={showLabel}
			overrides={
				overrides
					? mergeOverrides(customOverrides(props, HTMLAttrs), overrides as any)
					: customOverrides(props, HTMLAttrs)
			}
		/>
	);
});
